import { render, staticRenderFns } from "./Ai.vue?vue&type=template&id=44050968&scoped=true&"
import script from "./Ai.vue?vue&type=script&lang=js&"
export * from "./Ai.vue?vue&type=script&lang=js&"
import style0 from "./Ai.vue?vue&type=style&index=0&id=44050968&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44050968",
  null
  
)

export default component.exports